/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/media-has-caption */
import React, {
  FunctionComponent,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LightModeIcon from '@mui/icons-material/LightMode';
import NightlightRoundIcon from '@mui/icons-material/NightlightRound';
import ContrastIcon from '@mui/icons-material/Contrast';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RemoveIcon from '@mui/icons-material/Remove';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SubjectIcon from '@mui/icons-material/Subject';
import AddIcon from '@mui/icons-material/Add';
import {
  Card,
  Divider,
  IconButton,
  Menu,
  Stack,
  Typography,
} from '@mui/material';
import { LectionDivImageItem } from './LectionDivImageItem';
import { LectionDivTextItem } from './LectionDivTextItem';
import classes from './LictionDiv.module.css';
import { LectionSlideDto } from '../../dto/LectionImageDto';
import { MyButton } from '../UI/MyButton';
import ImageZoom from '../../image/Go-back.png';
import ImageZoom2 from '../../image/Go-back_2.png';
import ImageGo from '../../image/Go-forward.png';
import ImageGo2 from '../../image/Go-forward_2.png';
import { LECTION_ROUTE } from '../../constant/routes';
import {
  BIG_FONT_SIZE,
  BIG_VIDEO_SIZE,
  DARK_THEME,
  END_BUTTON_NAME,
  IMAGE_TYPE_BASE_AND_SELECT,
  IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK,
  IMAGE_TYPE_CROP,
  IMAGE_TYPE_VIDEO_POSTER,
  IMAGE_TYPE_ZOOM,
  IMAGE_TYPE_ZOOM_VIDEO,
  IMAGE_TYPE_ZOOM_WITH_BLACK,
  LIGHT_THEME,
  NEXT_BUTTON_NAME,
  NEXT_SLIDE_BUTTON_NAME,
  NORM_FONT_SIZE,
  NORM_VIDEO_SIZE,
  SMALL_FONT_SIZE,
  SMALL_VIDEO_SIZE,
  SYSTEM_THEME,
  TABLE_VIEW_CHANGE_WIDTH_WINDOW,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';
import {
  findSlideAndStepFromImageId,
  formatPositionToSlide,
  formatSlideToPosition,
  getClassName,
  getClassName2,
  GetFon,
  GetFon2,
  getInset,
  getMaxHeightConst,
  getMaxHeightConst2,
  selectTheme,
  viewOneSlideToAllSide,
} from '../../utils/utils';
import { LectionDivProgres2Item } from './LectionDivProgres2Item';
import { SlideHelpDto } from '../../dto/SlideHelpDto';
import { LectionDivTableItem } from './LectionDivTableItem';
import { DialogOnlyText } from '../dialog/DialogOnlyText';
import { ImageBase6444Dto } from '../../dto/ImageBase6444Dto';

interface Props {
  isPopup: boolean;
  dto: LectionSlideDto[];
  themeFromMain: number;
  selectPosition: number;
  onChange: (e: any) => void;
  onChange2: (e: any) => void;
  onChange5: (e: any) => void;
  onClosePopus?: () => void;
  dtoImagesBase6444?: ImageBase6444Dto[];
}

declare global {
  interface Window {
    webkit?: any;
    setTheme?: any;
    setPosition?: any;
    setScreenShot?: any;
  }
}

export const LectionDivSlideItem: FunctionComponent<Props> = ({
  isPopup,
  dto,
  dtoImagesBase6444,
  themeFromMain,
  selectPosition,
  onChange,
  onChange2,
  onChange5,
  onClosePopus,
}) => {
  const { section, lectionId } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [slide, setSlide] = useState(0);
  const [btnNext, setBtnNext] = useState(NEXT_BUTTON_NAME);
  const [btnBackDisabled, setBtnBackDisabled] = useState(true);
  const [btnNextDisabled, setBtnNextDisabled] = useState(false);
  const [fontSize, setFontSize] = useState(NORM_FONT_SIZE);
  const [isZoom, setIsZoom] = useState(false);
  const [windowState, setWindowState] = useState(WINDOW_V);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [, setIsAudio] = useState(false);
  const [videoQuality, setVideoQuality] = useState(NORM_VIDEO_SIZE);

  const [openDialogText, setOpenDialogText] = useState(false);

  const [scale, setScale] = useState(1);

  const [realSystemTheme] = useState(-1);
  const [curTheme, setCurTheme] = useState(themeFromMain);

  const [slideHelp, setSlideHelp] = useState<SlideHelpDto>({
    cnt: -1,
    imageId: '',
    isZoomVisible: false,
    isTable: false,
  });

  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollPositionImage, setScrollPositionImage] = useState(-1);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const checkFirstTime = () => {
    if (
      dto[slide].slideImages.length < 2 &&
      btnNext !== NEXT_SLIDE_BUTTON_NAME
    ) {
      if (slide === dto.length - 1) {
        // setBtnNext(END_BUTTON_NAME);
        // setBtnNextDisabled(false);
      } else {
        // setBtnNext(NEXT_SLIDE_BUTTON_NAME);
      }
    }
  };

  const chooseTextSizeFont = (sizeFont: string) => {
    setFontSize(sizeFont);
    handleClose();
  };

  const choseVidoQuality = (quality: string) => {
    setVideoQuality(quality);
    console.log(quality);
    handleClose();
  };

  const chooseTypeColorTheme = (colorType: number) => {
    setCurTheme(colorType);
    let colorBody = '#FFFFFF';
    if (colorType === DARK_THEME) {
      colorBody = '#1D2228';
    }
    document.body.style.background = colorBody;
    onChange(colorType);
    handleClose();
  };

  const [, setLect] = useState(
    dto[slide].text
      .replaceAll(
        'linkColor',
        selectTheme(dto[slide].selectTextColor, curTheme, realSystemTheme)
      )
      .replaceAll(
        dto[slide].slideImages.length > 0
          ? `id="${dto[slide].slideImages[step].id}" style="background-color: undefined;`
          : '',
        dto[slide].slideImages.length > 0
          ? `id="${
              dto[slide].slideImages[step].id
            }" style="background-color: ${selectTheme(
              dto[slide].selectBackgroundColor,
              curTheme,
              realSystemTheme
            )};`
          : ''
      )
  );

  const updateText = (slideNum: number, stepNum: number) => {
    if (dto[slideNum].slideImages.length > 0) {
      const selectedId = dto[slideNum].slideImages[stepNum].id;
      setLect(
        dto[slideNum].text
          .replaceAll(
            'linkColor',
            selectTheme(
              dto[slideNum].selectTextColor,
              curTheme,
              realSystemTheme
            )
          )
          .replaceAll(
            `id="${selectedId}" style="background-color: undefined;`,
            `id="${selectedId}" style="background-color: ${selectTheme(
              dto[slide].selectBackgroundColor,
              curTheme,
              realSystemTheme
            )};`
          )
      );
      navigate(`${LECTION_ROUTE}/${section}/${lectionId}/#${selectedId}`);
    }
  };

  const changeSlide = (val: number) => {
    // setBtnNextDisabled(false);
    setIsAudio(false);
    let slideCur = slide;
    const endSlide = dto.length - 1;
    slideCur += val;
    if (slideCur > endSlide) {
      slideCur = endSlide;
    }
    if (slideCur < 0) {
      slideCur = 0;
    }
    if (val > 0) {
      setStep(0);
      updateText(slideCur, 0);
    } else {
      const endStep = dto[slideCur].slideImages.length - 1;
      setStep(0);
      updateText(slideCur, endStep);
    }
    setSlide(slideCur);
    onChange5(formatSlideToPosition(slideCur, 0, 0));
  };

  const changeImageFromId = (imageId: string) => {
    const arr = findSlideAndStepFromImageId(imageId, dto);
    if (arr.length === 2) {
      const findSlide = arr[0];
      const findStep = arr[1];
      setSlide(findSlide);
      setStep(findStep);
      onChange5(formatSlideToPosition(findSlide, findStep, 0));
    }
  };

  const changeImage = (val: number) => {
    if (scrollPositionImage !== -1 && val < 0) {
      const div = document.getElementById('scrollableDiv');
      if (div !== null) {
        setBtnNext(NEXT_BUTTON_NAME);
        div.scrollTo({ top: scrollPositionImage, behavior: 'smooth' });
        console.log('scroll_1');
        setScrollPositionImage(-1);
        return;
      }
    }
    if (dto[slide].slideImages.length > 0) {
      let stepCur = step;
      stepCur += val;
      const endStep = dto[slide].slideImages.length - 1;
      const endSlide = dto.length - 1;

      if (val > 0 && stepCur > endStep && slide !== endSlide) {
        const div = document.getElementById('scrollableDiv');
        if (div !== null && btnNext !== NEXT_SLIDE_BUTTON_NAME) {
          if (div.scrollTop + div.clientHeight < div.scrollHeight) {
            /*
            setScrollPositionImage(div.scrollTop);
            div.scrollTo({ top: div.scrollHeight, behavior: 'smooth' });
            console.log('scroll_2_end');
            setBtnNext(NEXT_SLIDE_BUTTON_NAME);
            return;
            */
            setScrollPositionImage(div.scrollTop);

            // Всегда применяем быстрый хак перед скроллом
            const originalOverflow = div.style.overflow;
            div.style.overflow = 'hidden';
            // eslint-disable-next-line no-void
            void div.offsetHeight;
            div.style.overflow = originalOverflow || 'auto';

            // Smooth scroll к концу
            div.scrollTo({ top: div.scrollHeight, behavior: 'smooth' });

            // Через время гарантируем позицию
            setTimeout(() => {
              div.scrollTop = div.scrollHeight;
              console.log('scroll_2_end');
              setBtnNext(NEXT_SLIDE_BUTTON_NAME);
            }, 450);
            return;
          }
        }
      }

      if (val > 0 && btnNext === END_BUTTON_NAME) {
        onChange2(1);
        return;
      }

      if (val > 0 && stepCur > endStep && slide === endSlide) {
        const div = document.getElementById('scrollableDiv');
        if (div !== null && btnNext !== END_BUTTON_NAME) {
          if (div.scrollTop + div.clientHeight < div.scrollHeight) {
            setScrollPositionImage(div.scrollTop);
            div.scrollTo({ top: div.scrollHeight, behavior: 'smooth' });
            console.log('scroll_3');
            setBtnNext(END_BUTTON_NAME);
            return;
          }
          setBtnNext(END_BUTTON_NAME);
          onChange2(1);
          return;
        }
      }

      if (val > 0 && btnNext === NEXT_SLIDE_BUTTON_NAME) {
        const div = document.getElementById('scrollableDiv');
        if (div !== null) {
          /*
          const currentPosition = div.scrollTop;
          div.scrollTo({ top: div.scrollTop, behavior: 'smooth' });
          console.log('scroll_4');
          div.style.overflow = 'hidden';
          requestAnimationFrame(() => {
            div.style.overflow = 'smooth';
            div.scrollTop = currentPosition;
            console.log('scroll_5');
          });
          */

          const currentPosition = div.scrollTop;
          div.style.overflow = 'hidden';
          // eslint-disable-next-line no-void
          void div.offsetHeight; // Критически важный reflow для iOS
          div.style.overflow = 'auto';

          // Возвращаем позицию
          div.scrollTop = currentPosition;
          console.log('scroll_4');

          // Гарантия для iOS
          requestAnimationFrame(() => {
            div.scrollTop = currentPosition;
            console.log('scroll_5');
          });
        }
      }

      if (stepCur > endStep) {
        if (slide !== endSlide) {
          changeSlide(val);
        }
      } else if (stepCur < 0) {
        changeSlide(val);
        if (slide > 0) {
          setStep(dto[slide - 1].slideImages.length - 1);
          onChange5(
            formatSlideToPosition(
              slide,
              dto[slide - 1].slideImages.length - 1,
              0
            )
          );
        } else {
          setStep(0);
          onChange5(formatSlideToPosition(slide, 0, 0));
        }
      } else {
        setStep(stepCur);
        updateText(slide, stepCur);
        onChange5(formatSlideToPosition(slide, stepCur, 0));
      }
    } else {
      changeSlide(val);
    }
  };

  const changeZoom = (val: number) => {
    let curZoom = scale;
    if (val > 0) {
      if (curZoom < 1) {
        curZoom += 0.1;
      } else {
        curZoom += 0.5;
      }
      if (curZoom > 2) {
        curZoom = 2;
      }
    }
    if (val < 0) {
      if (curZoom <= 1) {
        curZoom -= 0.1;
      } else {
        curZoom -= 0.5;
      }
    }
    const cu1rZoom = Number(curZoom.toFixed(1));
    setScale(cu1rZoom);
  };

  const [dateTime, setDateTime] = useState(0);

  useEffect(() => {
    setScale(1);
    if (dto[slide].slideImages.length > 0) {
      setIsZoom(dto[slide].slideImages[step].zoomImage.name !== '');
      setSlideHelp({
        cnt: dto[slide].slideImages.length,
        imageId: dto[slide].slideImages[step].id,
        isZoomVisible:
          dto[slide].slideImages[step].type === IMAGE_TYPE_BASE_AND_SELECT ||
          dto[slide].slideImages[step].type ===
            IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK ||
          dto[slide].slideImages[step].type === IMAGE_TYPE_CROP ||
          dto[slide].slideImages[step].type === IMAGE_TYPE_ZOOM ||
          dto[slide].slideImages[step].type === IMAGE_TYPE_ZOOM_VIDEO ||
          dto[slide].slideImages[step].type === IMAGE_TYPE_ZOOM_WITH_BLACK,
        isTable: dto[slide].tableContent !== '',
      });
    } else {
      setSlideHelp({
        cnt: 0,
        imageId: '',
        isZoomVisible: false,
        isTable: false,
      });
    }
    checkFirstTime();
    setWindowWidth(window.innerWidth);
    let cnt = WINDOW_V;
    if (window.innerWidth > window.innerHeight) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
    const timestamp = Math.floor(Date.now() / 1000);
    setDateTime(timestamp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, slide]);

  const handleCloseDialogAllTest = (e: any) => {
    setScrollPosition(e);
    setOpenDialogText(false);
    // setSlideHelp({ ...slideHelp, imageId: e });
  };

  useEffect(() => {
    setCurTheme(themeFromMain);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeFromMain]);

  const [changeSetPosition, setChangeSetPosition] = useState(0);

  useEffect(() => {
    if (selectPosition >= 0) {
      setChangeSetPosition(1);
      const arrposition = formatPositionToSlide(selectPosition);
      setSlide(arrposition[0]);
      setStep(arrposition[1]);

      const endStep = dto[arrposition[0]].slideImages.length - 1;
      const endSlide = dto.length - 1;
      if (arrposition[1] === endStep && arrposition[0] !== endSlide) {
        const div = document.getElementById('scrollableDiv');
        if (div !== null) {
          if (div.scrollTop + div.clientHeight < div.scrollHeight) {
            setBtnNext(NEXT_BUTTON_NAME);
          } else {
            setBtnNext(NEXT_SLIDE_BUTTON_NAME);
          }
        }
      } else if (dto[arrposition[0]].slideImages.length > 1) {
        setBtnNext(NEXT_BUTTON_NAME);
      }
      if (arrposition[1] >= endStep && arrposition[0] === endSlide) {
        const div = document.getElementById('scrollableDiv');
        if (div !== null) {
          if (div.scrollTop + div.clientHeight < div.scrollHeight) {
            setBtnNext(NEXT_BUTTON_NAME);
          } else {
            setBtnNext(END_BUTTON_NAME);
          }
        }
      }
      if (arrposition[1] < 0) {
        if (arrposition[0] > 0) {
          setBtnNext(NEXT_SLIDE_BUTTON_NAME);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectPosition]);

  useEffect(() => {
    if (changeSetPosition === 0) {
      setStep(0);
    } else {
      setChangeSetPosition(0);
    }

    setScrollPositionImage(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide]);

  useEffect(() => {
    const endStep = dto[slide].slideImages.length - 1;
    const endSlide = dto.length - 1;
    setBtnBackDisabled(false);
    setBtnNextDisabled(false);
    if (step === endStep && slide !== endSlide) {
      const div = document.getElementById('scrollableDiv');
      if (div !== null) {
        if (div.scrollTop + div.clientHeight < div.scrollHeight) {
          setBtnNext(NEXT_BUTTON_NAME);
        } else {
          setBtnNext(NEXT_SLIDE_BUTTON_NAME);
        }
      }
    } else if (dto[slide].slideImages.length > 1) {
      setBtnNext(NEXT_BUTTON_NAME);
    }
    if (step >= endStep && slide === endSlide) {
      const div = document.getElementById('scrollableDiv');
      if (div !== null) {
        if (div.scrollTop + div.clientHeight < div.scrollHeight) {
          setBtnNext(NEXT_BUTTON_NAME);
        } else {
          setBtnNext(END_BUTTON_NAME);
          // setBtnNextDisabled(false);
        }
      }
    }
    if (step === 0 && slide === 0) {
      // setBtnBackDisabled(true);
    }
    if (step < 0) {
      if (slide > 0) {
        setBtnNext(NEXT_SLIDE_BUTTON_NAME);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateTime, selectPosition, themeFromMain]);

  const handlerChange = () => {
    let cnt = WINDOW_V;
    if (window.innerWidth > window.innerHeight) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
    setWindowWidth(window.innerWidth);
    setFontSize(NORM_FONT_SIZE);
  };

  useEffect(() => {
    setStep(0);
    setSlide(0);
    onChange5(formatSlideToPosition(0, 0, 0));
    setScrollPosition(0);
    const timestamp = Math.floor(Date.now() / 1000);
    setDateTime(timestamp);
    window.addEventListener('resize', handlerChange, false);
    return () => {
      window.removeEventListener('resize', handlerChange, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    const reset = () => {
      const div = document.getElementById('scrollableDiv');
      if (div) {
        div.scrollTop = 0;
        div.scrollTo({ top: 0, behavior: 'auto' });
      }
      window.scrollTo(0, 0);
    };

    reset();
    const raf = requestAnimationFrame(reset);
    const t = setTimeout(reset, 100); // после рендера картинок/шрифтов

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [slide]);

  return (
    <div
      style={{
        overscrollBehavior: 'none',
        overflow: 'hidden',
        userSelect: 'none',
        background: selectTheme(
          `${GetFon2(dto[slide].slideImages[step].type)};${GetFon(
            dto[slide].slideImages[step].type
          )}`,
          curTheme,
          realSystemTheme
        ),
      }}
      className={classes.myDiv4}
    >
      <div
        style={{
          height: '100%',
          width: '100%',
          overflow: 'hidden',
          paddingTop: 'var(--host-nav-overlap-top, 0px)',
          boxSizing: 'border-box', // важно!
        }}
      >
        <div
          className={getClassName(
            slideHelp.cnt > 0 && !slideHelp.imageId.includes('empty'),
            !(slideHelp.cnt > 0 && !slideHelp.imageId.includes('empty')),
            slideHelp.isTable,
            windowState
          )}
        >
          <div
            style={{
              background: !slideHelp.imageId.includes('empty')
                ? selectTheme(
                    `${GetFon2(dto[slide].slideImages[step].type)};${GetFon(
                      dto[slide].slideImages[step].type
                    )}`,
                    curTheme,
                    realSystemTheme
                  )
                : selectTheme(
                    dto[slide].backgroundText,
                    curTheme,
                    realSystemTheme
                  ),
            }}
            className={classes.divProgres}
          >
            <LectionDivProgres2Item
              curStep={step}
              curSlide={slide}
              dtos={dto}
              color={selectTheme(
                dto[slide].progressColor,
                curTheme,
                realSystemTheme
              )}
              background={
                curTheme === LIGHT_THEME ||
                (curTheme === SYSTEM_THEME && realSystemTheme === LIGHT_THEME)
                  ? '#80808080'
                  : '#404952FF'
              }
            />
          </div>
          {windowState === WINDOW_V && (
            <div
              style={{
                background: selectTheme(
                  `${GetFon2(dto[slide].slideImages[step].type)};${GetFon(
                    dto[slide].slideImages[step].type
                  )}`,
                  curTheme,
                  realSystemTheme
                ),
              }}
              className={classes.divImage}
              hidden={
                !(
                  slideHelp.cnt > 0 &&
                  !slideHelp.imageId.includes('empty') &&
                  windowState === WINDOW_V
                )
              }
            >
              <LectionDivImageItem
                curTheme={curTheme}
                step={step}
                slide={slide}
                isZoom={isZoom}
                dto={dto[slide]}
                dtoImagesBase6444={dtoImagesBase6444}
                windowState={windowState}
                videoSize={videoQuality}
              />
              <div
                style={{
                  position: 'fixed',
                  left: 20,
                  top: getMaxHeightConst() - 60 + getInset(),
                }}
                hidden={
                  !slideHelp.isZoomVisible ||
                  slideHelp.imageId.includes('empty')
                }
              >
                <MyButton
                  width="50px"
                  height="50px"
                  text={
                    isZoom ? (
                      <img
                        alt=""
                        src={
                          curTheme === LIGHT_THEME ||
                          (curTheme === SYSTEM_THEME &&
                            realSystemTheme === LIGHT_THEME)
                            ? ImageZoom
                            : ImageZoom2
                        }
                      />
                    ) : (
                      <img
                        alt=""
                        src={
                          curTheme === LIGHT_THEME ||
                          (curTheme === SYSTEM_THEME &&
                            realSystemTheme === LIGHT_THEME)
                            ? ImageGo
                            : ImageGo2
                        }
                      />
                    )
                  }
                  background={selectTheme(
                    dto[slide].backgroundText,
                    curTheme,
                    realSystemTheme
                  )}
                  onClick={() => setIsZoom(!isZoom)}
                />
              </div>
            </div>
          )}
          {!slideHelp.isTable && windowState === WINDOW_V && (
            <div
              style={{
                background: selectTheme(
                  dto[slide].backgroundText,
                  curTheme,
                  realSystemTheme
                ),
              }}
              className={
                slideHelp.cnt > 0 && !slideHelp.imageId.includes('empty')
                  ? classes.divPlanka
                  : classes.divPlanka2
              }
            >
              {' '}
            </div>
          )}
          {windowState === WINDOW_V && (
            <div
              id="scrollableDiv"
              style={{
                background: selectTheme(
                  dto[slide].backgroundText,
                  curTheme,
                  realSystemTheme
                ),
              }}
              hidden={windowState !== WINDOW_V}
              className={
                !slideHelp.isTable ? classes.divText : classes.divTable
              }
            >
              <div hidden={slideHelp.isTable}>
                <LectionDivTextItem
                  isOpenOnlyText={openDialogText}
                  curTheme={curTheme}
                  realSystemTheme={realSystemTheme}
                  selectedId={slideHelp.cnt > 0 ? slideHelp.imageId : ''}
                  dto={dto[slide]}
                  slideNum={slide}
                  fontSize={fontSize}
                  onClick={changeImageFromId}
                />
              </div>
              <div hidden={!slideHelp.isTable}>
                <LectionDivTableItem
                  scaleNew={scale}
                  curTheme={curTheme}
                  realSystemTheme={realSystemTheme}
                  dto={dto[slide]}
                  fontSize={fontSize}
                />
              </div>
            </div>
          )}
          {windowState === WINDOW_H && (
            <div
              style={{
                background: selectTheme(
                  dto[slide].backgroundText,
                  curTheme,
                  realSystemTheme
                ),
              }}
              className={getClassName2(
                slideHelp.cnt,
                slideHelp.imageId.includes('empty'),
                slideHelp.isTable
              )}
            >
              <div
                style={{
                  background: selectTheme(
                    `${GetFon2(dto[slide].slideImages[step].type)};${GetFon(
                      dto[slide].slideImages[step].type
                    )}`,
                    curTheme,
                    realSystemTheme
                  ),
                }}
                className={classes.divImage}
                hidden={
                  !(slideHelp.cnt > 0 && !slideHelp.imageId.includes('empty'))
                }
              >
                <LectionDivImageItem
                  curTheme={curTheme}
                  step={step}
                  slide={slide}
                  isZoom={isZoom}
                  dto={dto[slide]}
                  dtoImagesBase6444={dtoImagesBase6444}
                  windowState={windowState}
                  videoSize={videoQuality}
                />
                <div
                  style={{
                    position: 'fixed',
                    left: 20,
                    top: getMaxHeightConst2() - 65 + getInset(),
                  }}
                  hidden={
                    !slideHelp.isZoomVisible ||
                    slideHelp.imageId.includes('empty')
                  }
                >
                  <MyButton
                    width="50px"
                    height="50px"
                    text={
                      isZoom ? (
                        <img
                          alt=""
                          src={
                            curTheme === LIGHT_THEME ||
                            (curTheme === SYSTEM_THEME &&
                              realSystemTheme === LIGHT_THEME)
                              ? ImageZoom
                              : ImageZoom2
                          }
                        />
                      ) : (
                        <img
                          alt=""
                          src={
                            curTheme === LIGHT_THEME ||
                            (curTheme === SYSTEM_THEME &&
                              realSystemTheme === LIGHT_THEME)
                              ? ImageGo
                              : ImageGo2
                          }
                        />
                      )
                    }
                    background={selectTheme(
                      dto[slide].backgroundText,
                      curTheme,
                      realSystemTheme
                    )}
                    onClick={() => setIsZoom(!isZoom)}
                  />
                </div>
              </div>
              <div
                id="scrollableDiv"
                style={{
                  background: selectTheme(
                    dto[slide].backgroundText,
                    curTheme,
                    realSystemTheme
                  ),
                  marginTop: '10px',
                  marginBottom: '90px',
                }}
                className={
                  !slideHelp.isTable ? classes.divText : classes.divTable
                }
              >
                <div hidden={slideHelp.isTable}>
                  <LectionDivTextItem
                    isOpenOnlyText={openDialogText}
                    curTheme={curTheme}
                    realSystemTheme={realSystemTheme}
                    selectedId={slideHelp.cnt > 0 ? slideHelp.imageId : ''}
                    dto={dto[slide]}
                    slideNum={slide}
                    fontSize={fontSize}
                    onClick={changeImageFromId}
                  />
                </div>
                <div hidden={!slideHelp.isTable}>
                  <LectionDivTableItem
                    scaleNew={scale}
                    curTheme={curTheme}
                    realSystemTheme={realSystemTheme}
                    dto={dto[slide]}
                    fontSize={fontSize}
                  />
                </div>
              </div>
              <Card
                style={{
                  width: '50%',
                  height: '75px',
                  position: 'fixed',
                  bottom: 0,
                  right: 0,
                  borderRadius: '0px',
                  background: selectTheme(
                    dto[slide].backgroundText,
                    curTheme,
                    realSystemTheme
                  ),
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  height="65px"
                  direction="row"
                  spacing={1}
                >
                  <Stack direction="row" spacing={1} marginRight="15px">
                    {slideHelp.isTable && (
                      <MyButton
                        width="44px"
                        height="44px"
                        text={
                          <RemoveIcon
                            sx={{
                              color: selectTheme(
                                dto[slide].buttonColor2,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                          />
                        }
                        disabled={btnBackDisabled}
                        background={selectTheme(
                          dto[slide].buttonColor,
                          curTheme,
                          realSystemTheme
                        )}
                        onClick={() => changeZoom(-1)}
                      />
                    )}

                    {slideHelp.isTable && (
                      <MyButton
                        width="44px"
                        height="44px"
                        text={
                          <AddIcon
                            sx={{
                              color: selectTheme(
                                dto[slide].buttonColor2,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                          />
                        }
                        disabled={btnBackDisabled}
                        background={selectTheme(
                          dto[slide].buttonColor,
                          curTheme,
                          realSystemTheme
                        )}
                        onClick={() => changeZoom(1)}
                      />
                    )}

                    {slideHelp.isTable && (
                      <Stack
                        width="100px"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '16px',
                            color: selectTheme(
                              dto[slide].textColor,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                          component="text"
                        >
                          {scale}x
                        </Typography>
                      </Stack>
                    )}

                    {!slideHelp.isTable && isPopup && (
                      <MyButton
                        width="195px"
                        height="44px"
                        text="Закрыть"
                        disabled={btnNextDisabled}
                        color={selectTheme(
                          dto[slide].buttonColor2,
                          curTheme,
                          realSystemTheme
                        )}
                        background={selectTheme(
                          dto[slide].buttonColor,
                          curTheme,
                          realSystemTheme
                        )}
                        onClick={onClosePopus}
                      />
                    )}

                    {!slideHelp.isTable && !isPopup && (
                      <IconButton
                        size="small"
                        onClick={(e) => handleClick(e)}
                        disableRipple
                      >
                        <MoreVertIcon
                          sx={{
                            color: selectTheme(
                              '#000000;#848d95',
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                        />
                      </IconButton>
                    )}
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      sx={{
                        mt: '1px',
                        '& .MuiMenu-paper': {
                          backgroundColor: selectTheme(
                            '#FFFFFF;#404952',
                            curTheme,
                            realSystemTheme
                          ),
                        },
                      }}
                    >
                      <Stack padding="5px" alignItems="center">
                        {dto[slide].isAndroid !== '1' && (
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            component="text"
                          >
                            Тема
                          </Typography>
                        )}
                        {dto[slide].isAndroid !== '1' && (
                          <Stack direction="row" spacing={1}>
                            <IconButton
                              size="large"
                              onClick={() => chooseTypeColorTheme(LIGHT_THEME)}
                              disableRipple
                            >
                              <LightModeIcon
                                sx={{
                                  color: selectTheme(
                                    dto[slide].textColor,
                                    curTheme,
                                    realSystemTheme
                                  ),
                                }}
                              />
                            </IconButton>
                            <IconButton
                              size="large"
                              onClick={() => chooseTypeColorTheme(DARK_THEME)}
                              disableRipple
                            >
                              <NightlightRoundIcon
                                sx={{
                                  fontSize: '20px',
                                  color: selectTheme(
                                    dto[slide].textColor,
                                    curTheme,
                                    realSystemTheme
                                  ),
                                }}
                              />
                            </IconButton>
                            <IconButton
                              size="large"
                              onClick={() => chooseTypeColorTheme(SYSTEM_THEME)}
                              disableRipple
                            >
                              <ContrastIcon
                                sx={{
                                  fontSize: '20px',
                                  color: selectTheme(
                                    dto[slide].textColor,
                                    curTheme,
                                    realSystemTheme
                                  ),
                                }}
                              />
                            </IconButton>
                          </Stack>
                        )}
                        {dto[slide].isAndroid !== '1' && (
                          <Divider sx={{ width: '90%' }} />
                        )}
                        <Typography
                          style={{
                            paddingTop: '10px',
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '14px',
                            textAlign: 'center',
                            color: selectTheme(
                              dto[slide].textColor,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                          component="text"
                        >
                          Шрифт
                        </Typography>
                        <Stack
                          direction="row"
                          paddingTop="10px"
                          paddingBottom="10px"
                          spacing={3}
                        >
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => chooseTextSizeFont(SMALL_FONT_SIZE)}
                            component="text"
                          >
                            {SMALL_FONT_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => chooseTextSizeFont(NORM_FONT_SIZE)}
                            component="text"
                          >
                            {NORM_FONT_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => chooseTextSizeFont(BIG_FONT_SIZE)}
                            component="text"
                          >
                            {BIG_FONT_SIZE}
                          </Typography>
                        </Stack>
                        <Divider sx={{ width: '90%' }} />
                        <Typography
                          style={{
                            paddingTop: '10px',
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '14px',
                            textAlign: 'center',
                            color: selectTheme(
                              dto[slide].textColor,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                          component="text"
                        >
                          Качество видео
                        </Typography>
                        <Stack
                          direction="row"
                          paddingTop="10px"
                          paddingBottom="10px"
                          spacing={2}
                        >
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                videoQuality === SMALL_VIDEO_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => choseVidoQuality(SMALL_VIDEO_SIZE)}
                            component="text"
                          >
                            {SMALL_VIDEO_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                videoQuality === NORM_VIDEO_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => choseVidoQuality(NORM_VIDEO_SIZE)}
                            component="text"
                          >
                            {NORM_VIDEO_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                videoQuality === BIG_VIDEO_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => choseVidoQuality(BIG_VIDEO_SIZE)}
                            component="text"
                          >
                            {BIG_VIDEO_SIZE}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Menu>

                    {!slideHelp.isTable && !isPopup && (
                      <IconButton
                        size="small"
                        onClick={() => setOpenDialogText(true)}
                        disableRipple
                      >
                        <SubjectIcon
                          sx={{
                            color: selectTheme(
                              '#000000;#848d95',
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                        />
                      </IconButton>
                    )}
                  </Stack>

                  <div
                    style={{
                      marginRight: '10px',
                    }}
                  >
                    {' '}
                  </div>

                  <MyButton
                    width="44px"
                    height="44px"
                    text={
                      <KeyboardArrowLeftIcon
                        sx={{
                          color: selectTheme(
                            dto[slide].buttonColor2,
                            curTheme,
                            realSystemTheme
                          ),
                        }}
                      />
                    }
                    disabled={btnBackDisabled}
                    background={selectTheme(
                      dto[slide].buttonColor,
                      curTheme,
                      realSystemTheme
                    )}
                    onClick={() => changeImage(-1)}
                  />

                  {(slideHelp.isTable || isPopup) && (
                    <MyButton
                      width="44px"
                      height="44px"
                      text={
                        <KeyboardArrowRightIcon
                          sx={{
                            color: selectTheme(
                              dto[slide].buttonColor2,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                        />
                      }
                      disabled={btnNextDisabled}
                      background={selectTheme(
                        dto[slide].buttonColor,
                        curTheme,
                        realSystemTheme
                      )}
                      onClick={() => changeImage(1)}
                    />
                  )}

                  {!slideHelp.isTable && !isPopup && (
                    <MyButton
                      width="195px"
                      height="44px"
                      text={btnNext}
                      disabled={btnNextDisabled}
                      color={selectTheme(
                        dto[slide].buttonColor2,
                        curTheme,
                        realSystemTheme
                      )}
                      background={selectTheme(
                        dto[slide].buttonColor,
                        curTheme,
                        realSystemTheme
                      )}
                      onClick={() => changeImage(1)}
                    />
                  )}
                  <div
                    style={{
                      marginRight: '10px',
                    }}
                  >
                    {' '}
                  </div>
                </Stack>
              </Card>
            </div>
          )}
          {windowState === WINDOW_V && (
            <div
              style={{
                width: windowState === WINDOW_V ? '100%' : '50%',
                background: selectTheme(
                  dto[slide].backgroundText,
                  curTheme,
                  realSystemTheme
                ),
              }}
              className={classes.divButton}
            >
              <Card
                style={{
                  height: '75px',
                  bottom: 0,
                  left: 0,
                  borderRadius: '0px',
                  background: selectTheme(
                    dto[slide].backgroundText,
                    curTheme,
                    realSystemTheme
                  ),
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  height="65px"
                  direction="row"
                  spacing={1}
                >
                  <Stack direction="row" spacing={1} marginRight="15px">
                    {slideHelp.isTable && (
                      <MyButton
                        width="44px"
                        height="44px"
                        text={
                          <RemoveIcon
                            sx={{
                              color: selectTheme(
                                dto[slide].buttonColor2,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                          />
                        }
                        disabled={btnBackDisabled}
                        background={selectTheme(
                          dto[slide].buttonColor,
                          curTheme,
                          realSystemTheme
                        )}
                        onClick={() => changeZoom(-1)}
                      />
                    )}

                    {slideHelp.isTable && (
                      <MyButton
                        width="44px"
                        height="44px"
                        text={
                          <AddIcon
                            sx={{
                              color: selectTheme(
                                dto[slide].buttonColor2,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                          />
                        }
                        disabled={btnBackDisabled}
                        background={selectTheme(
                          dto[slide].buttonColor,
                          curTheme,
                          realSystemTheme
                        )}
                        onClick={() => changeZoom(1)}
                      />
                    )}

                    {slideHelp.isTable && (
                      <Stack
                        width="100px"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          style={{
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '16px',
                            color: selectTheme(
                              dto[slide].textColor,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                          component="text"
                        >
                          {scale}x
                        </Typography>
                      </Stack>
                    )}

                    {!slideHelp.isTable && isPopup && (
                      <MyButton
                        width="195px"
                        height="44px"
                        text="Закрыть"
                        disabled={btnNextDisabled}
                        color={selectTheme(
                          dto[slide].buttonColor2,
                          curTheme,
                          realSystemTheme
                        )}
                        background={selectTheme(
                          dto[slide].buttonColor,
                          curTheme,
                          realSystemTheme
                        )}
                        onClick={onClosePopus}
                      />
                    )}

                    {!slideHelp.isTable && !isPopup && (
                      <IconButton
                        size="small"
                        onClick={(e) => handleClick(e)}
                        disableRipple
                      >
                        <MoreVertIcon
                          sx={{
                            color: selectTheme(
                              '#000000;#848d95',
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                        />
                      </IconButton>
                    )}
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      sx={{
                        mt: '1px',
                        '& .MuiMenu-paper': {
                          backgroundColor: selectTheme(
                            '#FFFFFF;#404952',
                            curTheme,
                            realSystemTheme
                          ),
                        },
                      }}
                    >
                      <Stack padding="5px" alignItems="center">
                        {dto[slide].isAndroid !== '1' && (
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            component="text"
                          >
                            Тема
                          </Typography>
                        )}
                        {dto[slide].isAndroid !== '1' && (
                          <Stack direction="row" spacing={1}>
                            <IconButton
                              size="large"
                              onClick={() => chooseTypeColorTheme(LIGHT_THEME)}
                              disableRipple
                            >
                              <LightModeIcon
                                sx={{
                                  color: selectTheme(
                                    dto[slide].textColor,
                                    curTheme,
                                    realSystemTheme
                                  ),
                                }}
                              />
                            </IconButton>
                            <IconButton
                              size="large"
                              onClick={() => chooseTypeColorTheme(DARK_THEME)}
                              disableRipple
                            >
                              <NightlightRoundIcon
                                sx={{
                                  fontSize: '20px',
                                  color: selectTheme(
                                    dto[slide].textColor,
                                    curTheme,
                                    realSystemTheme
                                  ),
                                }}
                              />
                            </IconButton>
                            <IconButton
                              size="large"
                              onClick={() => chooseTypeColorTheme(SYSTEM_THEME)}
                              disableRipple
                            >
                              <ContrastIcon
                                sx={{
                                  fontSize: '20px',
                                  color: selectTheme(
                                    dto[slide].textColor,
                                    curTheme,
                                    realSystemTheme
                                  ),
                                }}
                              />
                            </IconButton>
                          </Stack>
                        )}
                        {dto[slide].isAndroid !== '1' && (
                          <Divider sx={{ width: '90%' }} />
                        )}
                        <Typography
                          style={{
                            paddingTop: '10px',
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '14px',
                            textAlign: 'center',
                            color: selectTheme(
                              dto[slide].textColor,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                          component="text"
                        >
                          Шрифт
                        </Typography>
                        <Stack
                          direction="row"
                          paddingTop="10px"
                          paddingBottom="10px"
                          spacing={3}
                        >
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                fontSize === SMALL_FONT_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => chooseTextSizeFont(SMALL_FONT_SIZE)}
                            component="text"
                          >
                            {SMALL_FONT_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                fontSize === NORM_FONT_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => chooseTextSizeFont(NORM_FONT_SIZE)}
                            component="text"
                          >
                            {NORM_FONT_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                fontSize === BIG_FONT_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => chooseTextSizeFont(BIG_FONT_SIZE)}
                            component="text"
                          >
                            {BIG_FONT_SIZE}
                          </Typography>
                        </Stack>
                        <Divider sx={{ width: '90%' }} />
                        <Typography
                          style={{
                            paddingTop: '10px',
                            fontFamily: 'sans-serif',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '14px',
                            textAlign: 'center',
                            color: selectTheme(
                              dto[slide].textColor,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                          component="text"
                        >
                          Качество видео
                        </Typography>
                        <Stack
                          direction="row"
                          paddingTop="10px"
                          paddingBottom="10px"
                          spacing={2}
                        >
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                videoQuality === SMALL_VIDEO_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => choseVidoQuality(SMALL_VIDEO_SIZE)}
                            component="text"
                          >
                            {SMALL_VIDEO_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                videoQuality === NORM_VIDEO_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => choseVidoQuality(NORM_VIDEO_SIZE)}
                            component="text"
                          >
                            {NORM_VIDEO_SIZE}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: 'sans-serif',
                              fontStyle: 'normal',
                              fontWeight:
                                videoQuality === BIG_VIDEO_SIZE ? 700 : 400,
                              fontSize: '14px',
                              textAlign: 'center',
                              color: selectTheme(
                                dto[slide].textColor,
                                curTheme,
                                realSystemTheme
                              ),
                            }}
                            onClick={() => choseVidoQuality(BIG_VIDEO_SIZE)}
                            component="text"
                          >
                            {BIG_VIDEO_SIZE}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Menu>

                    {!slideHelp.isTable && !isPopup && (
                      <IconButton
                        size="small"
                        onClick={() => setOpenDialogText(true)}
                        disableRipple
                      >
                        <SubjectIcon
                          sx={{
                            color: selectTheme(
                              '#000000;#848d95',
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                        />
                      </IconButton>
                    )}
                  </Stack>

                  <div
                    style={{
                      marginRight: '10px',
                    }}
                  >
                    {' '}
                  </div>

                  <MyButton
                    width="44px"
                    height="44px"
                    text={
                      <KeyboardArrowLeftIcon
                        sx={{
                          color: selectTheme(
                            dto[slide].buttonColor2,
                            curTheme,
                            realSystemTheme
                          ),
                        }}
                      />
                    }
                    disabled={btnBackDisabled}
                    background={selectTheme(
                      dto[slide].buttonColor,
                      curTheme,
                      realSystemTheme
                    )}
                    onClick={() => changeImage(-1)}
                  />

                  {(slideHelp.isTable || isPopup) && (
                    <MyButton
                      width="44px"
                      height="44px"
                      text={
                        <KeyboardArrowRightIcon
                          sx={{
                            color: selectTheme(
                              dto[slide].buttonColor2,
                              curTheme,
                              realSystemTheme
                            ),
                          }}
                        />
                      }
                      disabled={btnNextDisabled}
                      background={selectTheme(
                        dto[slide].buttonColor,
                        curTheme,
                        realSystemTheme
                      )}
                      onClick={() => changeImage(1)}
                    />
                  )}

                  {!slideHelp.isTable && !isPopup && (
                    <MyButton
                      width="195px"
                      height="44px"
                      text={btnNext}
                      disabled={btnNextDisabled}
                      color={selectTheme(
                        dto[slide].buttonColor2,
                        curTheme,
                        realSystemTheme
                      )}
                      background={selectTheme(
                        dto[slide].buttonColor,
                        curTheme,
                        realSystemTheme
                      )}
                      onClick={() => changeImage(1)}
                    />
                  )}
                </Stack>
              </Card>
            </div>
          )}
        </div>
      </div>

      <DialogOnlyText
        slideNum={slide}
        curTheme={curTheme}
        dto={viewOneSlideToAllSide(dto)}
        scrollPostion={scrollPosition}
        open={openDialogText}
        fontSize={fontSize}
        onClose={handleCloseDialogAllTest}
      />
    </div>
  );
};

LectionDivSlideItem.defaultProps = {
  onClosePopus: undefined,
  dtoImagesBase6444: undefined,
};
